export default __webpack_public_path__ + "images/90d750463ed138960b9ab783cbffda6e.png";